import React from "react";
import { connect } from "react-redux";
import "./styles/MarketStoreSlider.css";
import ModalStoreFollowers from "./ModalStoreFollowers";
import ModalStoreAbout from "./ModalStoreAbout";
import ModalStoreContacts from "./ModalStoreContacts";
import ModalStoreLocation from "./ModalStoreLocation";
import * as actions from "../redux/actions/marketStoreFollowersActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";

class MarketStoreSlider extends React.Component {
  state = {
    open_modal_followers: false,
    open_modal_home: false,
    open_modal_location: false,
    open_modal_contact: false,
  };

  fechFollowers = async () => {
    if (!this.props.marketstore?.Id) return;

    try {
      await this.props.LoadFollowers(this.props.token, {
        store_id: this.props.marketstore.Id,
        id: this.props.user_id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  isLoggedIn = () =>
    Boolean(this.props.user_id && this.props.token);

  requireLogin = () => {
    alertify.alert(I18n.t("warning"), I18n.t("warning_login"), function () {});
  };

  onClickFollow = async () => {
    if (!this.isLoggedIn()) {
      this.requireLogin();
      return;
    }
    try {
      await this.props
        .UpdateFollow(this.props.token, {
          store_id: this.props.marketstore.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickUnFollow = async () => {
    if (!this.isLoggedIn()) {
      this.requireLogin();
      return;
    }
    try {
      await this.props
        .UpdateFollow(this.props.token, {
          store_id: this.props.marketstore.Id,
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.error) {
            alertify.warning(I18n.t(this.props.error));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onClickFollowers = () => {
    if (!this.isLoggedIn()) {
      this.requireLogin();
      return;
    }
    this.setState({ open_modal_followers: true });
    this.fechFollowers();
  };

  onClose = () => {
    this.setState({ open_modal_followers: false });
  };

  onClickHome = () => {
    this.setState({ open_modal_home: !this.state.open_modal_home });
  };

  onClickLocation = () => {
    this.setState({ open_modal_location: !this.state.open_modal_location });
  };

  onClickContact = () => {
    this.setState({ open_modal_contact: !this.state.open_modal_contact });
  };

  render() {
    const { marketstore } = this.props;
    const coverStyle = marketstore.BackGroundPicturePage
      ? { backgroundImage: `url(${marketstore.BackGroundPicturePage})` }
      : {};

    return (
      <div className="marketstore-hero-card card hovercard">
        <div className="marketstore-hero-cover" style={coverStyle}>
          <div className="marketstore-hero-overlay" />
          <div className="marketstore-hero-content">
            <div className="marketstore-hero-logo">
              <img src={marketstore.Logo} alt={marketstore.Name || "Store"} />
            </div>
            <h1
              className="marketstore-hero-title"
              style={marketstore.TextColor ? { color: marketstore.TextColor } : undefined}
            >
              {marketstore.Name}
            </h1>
            {marketstore.Description && (
              <p className="marketstore-hero-description">{marketstore.Description}</p>
            )}
          </div>
        </div>

        <div className="marketstore-hero-actions">
          <div className="marketstore-hero-actions-primary">
            {marketstore.IsFollow ? (
              <button
                type="button"
                className="marketstore-btn marketstore-btn--outline"
                onClick={this.onClickUnFollow}
              >
                <Translate value="marketstore_unfollow" />
              </button>
            ) : (
              <button
                type="button"
                className="marketstore-btn marketstore-btn--primary"
                onClick={this.onClickFollow}
              >
                <Translate value="marketstore_follow" />
              </button>
            )}
            <button
              type="button"
              className="marketstore-btn marketstore-btn--ghost"
              onClick={this.onClickFollowers}
            >
              <span className="marketstore-followers-count">
                {marketstore.FollowCount ?? 0}
              </span>
              <Translate value="marketstore_followers" />
            </button>
          </div>

          <div className="marketstore-hero-actions-links">
            <button
              type="button"
              className="marketstore-link-chip"
              onClick={this.onClickHome}
            >
              <Translate value="marketstore_about_us" />
            </button>
            <button
              type="button"
              className="marketstore-link-chip"
              onClick={this.onClickLocation}
            >
              <Translate value="marketstore_location" />
            </button>
            <button
              type="button"
              className="marketstore-link-chip"
              onClick={this.onClickContact}
            >
              <Translate value="footer_contacts" />
            </button>
          </div>
        </div>

        <ModalStoreFollowers
          isOpen={this.state.open_modal_followers}
          followerList={this.props.followerList}
          onClose={this.onClose}
        />
        <ModalStoreAbout
          isOpen={this.state.open_modal_home}
          onClose={this.onClickHome}
          marketstore={marketstore}
        />
        <ModalStoreLocation
          isOpen={this.state.open_modal_location}
          onClose={this.onClickLocation}
          marketstore={marketstore}
        />
        <ModalStoreContacts
          isOpen={this.state.open_modal_contact}
          onClose={this.onClickContact}
          marketstore={marketstore}
        />
      </div>
    );
  }
}

function mapStateToProps(reducers) {
  return {
    user_id: reducers.session.auth.id,
    token: reducers.session.auth.access_token,
    marketstore: reducers.marketstore.item,
    error: reducers.marketstoreFollowers.error,
    followerList: reducers.marketstoreFollowers.list,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadFollowers: (token, params) =>
    dispatch(actions.loadList({ token, params })),
  UpdateFollow: (token, params) =>
    dispatch(actions.updateItem({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketStoreSlider);
